export const AllowedTranslationKey = [
  'vbeiUniqueID',
  'vbeiLimitSetNameNoSpace',
  'vbeiRowType',
  'vbeiRuleType',
  'vbeiFilterName',
  'vbeiFilterValue',
  'vbeiAccount',
  'vbeiAccountHeader',
  'vbeiTranslationLanguage',
  'vbeiTranslationValue',
  'vbeiUnits',
  'vbeiComplianceLevelNoSpace',
  'vbeiTemplate',
  'vbeiLimits',
  'vbeiDefinition',
  'vbeiTranslation',
  'vbeiStyleTemplateNoSpace',
  'vbeiScope',
  'vbeiTestParameter',
  'vbeiParameter',
  'vbeiCustom',
  'vbeiMatrix',
  'vbeiSamplingPoint',
  'vbeiGood',
  'vbeiAcceptable',
  'vbeiAverage',
  'vbeiBad',
  'vbeiPoor',
  'vbeiSamplingPointNoSpace',
  'vbeiRpCode',
  'vbeiGroup',
  'vbeiRPCodeMrl',
  'vbeiRPCodeArfd',
  'vbeiRPCodeCount',
  'vbeiRPCodeParameterDetect'
];
